<template>
    <v-container fluid>
        <h1>Crear equipos</h1>
        <v-form>
            <v-container>
                <v-row v-if="!disponible">
                    <v-col cols="12" sm="6">
                        <v-radio-group v-model="opcion" row
                                       label="Me gustaría: "
                        >
                            <v-radio label="Crear equipo nuevo" :value=false></v-radio>
                            <v-radio label="Añadir personas a un equipo" :value=true></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="!opcion">
                        <v-text-field
                                label="Nombre del equipo"
                                outlined
                                v-model="nuevo"
                                :rules="nuevoRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" v-else>
                        <v-autocomplete
                                label="Equipo"
                                :items="disponibles"
                                item-value="id"
                                item-text="nombre"
                                v-model="equipo"
                                @change="seleccionado"
                        >
                            <template v-slot:item="data">
                                {{ data.item.nombre }}<sup>({{data.item.integrantes}})</sup>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-btn large color="success"
                               :disabled="(!opcion && nuevo < 3) || (opcion && equipo==0)"
                               @click="accion">Aceptar</v-btn>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12">
                        <h3>Selecciona los integrantes del equipo: {{ nombre }}</h3>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                                label="Primer integrante"
                                :items="inscritos"
                                item-value="id"
                                item-text="nombre"
                                v-model="seleccionados.uno"
                                :item-disabled="(item) => [seleccionados.cuatro, seleccionados.tres, seleccionados.dos].includes(item.id)"
                        >

                        </v-autocomplete>

                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                                label="Segundo integrante"
                                :items="inscritos"
                                item-value="id"
                                item-text="nombre"
                                v-model="seleccionados.dos"
                                :disabled="!(integrantes < 3)"
                                :item-disabled="(item) => [seleccionados.cuatro, seleccionados.tres, seleccionados.uno].includes(item.id)"
                        >

                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                                label="Tercer integrante"
                                :items="inscritos"
                                item-value="id"
                                item-text="nombre"
                                v-model="seleccionados.tres"
                                :disabled="!(integrantes < 2)"
                                :item-disabled="(item) => [seleccionados.cuatro, seleccionados.dos, seleccionados.uno].includes(item.id)"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                                label="Cuarto integrante"
                                :items="inscritos"
                                item-value="id"
                                item-text="nombre"
                                v-model="seleccionados.cuatro"
                                :disabled="integrantes > 0 "
                                :item-disabled="(item) => [seleccionados.tres, seleccionados.dos, seleccionados.uno].includes(item.id)"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-btn color="success"
                               @click="registrarEquipo"
                        >Aceptar</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-dialog v-model="error" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline myModal">El equipo que has introducido ya existe</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="error = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="exito" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline myModal">El equipo {{nombre}} se ha registrado correctamente</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
<!--                    <v-btn color="red darken-1" text @click="exito = false">Cerrar</v-btn>-->
                    <v-btn color="green darken-1" text @click="haciaListado">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { equService, insService } from '@/_services'
    export default {
        name: "RegistraEquipo",
        props: ['carrera'],
        data() {
            return {
                equipo:0,
                integrantes: 4,
                nombre: '',
                opcion: false,
                disponible: false,
                disponibles: [],
                nuevo:'',
                inscritos:[],
                nuevoRules: [
                    v => (v && v.length >= 3) || 'El nombre debe de tener 3 carácteres o más'
                ],
                error: false,
                seleccionados: {
                    uno: 0,
                    dos: 0,
                    tres: 0,
                    cuatro: 0
                },
                exito: false
            }
        },
        created() {
            equService.getEquipos().then( data => this.disponibles = data.equipos)
            insService.getInscritosSinEquipo(this.carrera).then(data => {
                data.forEach( ins => {
                    const persona = {
                        id: ins.id,
                        nombre: `${ins.nombre.toUpperCase()} ${ins.apellidos.toUpperCase()}`
                    }
                    this.inscritos.push(persona)
                })
            })
        },
        methods: {
            accion(){
                if(this.opcion){
                    this.disponible = true
                }else {
                    this.crearEquipo()
                }
            },
            seleccionado() {

                const a = this.disponibles.find( (eq) => eq.id == this.equipo )
                this.integrantes = parseInt(a.integrantes)
            },
            crearEquipo() {
                const equipo = {
                    nombre: this.nuevo.toUpperCase()
                }
                equService.generarEquipo(equipo).then( data => {
                    if(data.success){
                        this.equipo = data.idEquipo
                        this.nombre = this.nuevo.toUpperCase()
                        this.disponible = true
                        this.integrantes = 0
                    }else {
                        this.error = true
                        this.disponible = false
                    }
                })
            },
            registrarEquipo() {
                const data = {
                    idEquipo: this.equipo,
                    seleccionados: this.seleccionados
                };
                equService.registrarEquipo(data).then(rdo => {

                    if(rdo.success) {
                        this.exito = true
                    }
                })
            },
            haciaListado() {
                const ruta = (this.carrera == 1) ? 'listado' : 'listadoCorta'
                this.$router.push({
                    name: 'listado',
                    params: { name: ruta, carrera: this.carrera }
                })
            }
        }
    }
</script>


<style scoped>

</style>